import React from 'react'
import DownloadMessagesContent from './Ui/Blocks/DownloadMessagesContent'

const DownloadMessages = () => {
  return <DownloadMessagesContent />
}

export default DownloadMessages 